import Header from './components/Header';
import Hero from './components/Hero';
import RankingSection from './components/RankingSection';
import IndexSection from './components/IndexSection';
import CommentsSection from './components/CommentsSection';
import { AboutSection, ContactSection, AppSection } from './components/AboutContactApp';
import UpdatesSection from './components/UpdatesSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import FAQSection from './components/FAQSection';
import CarouselSection from './components/CarouselSection';
import MediaSection from './components/MediaSection';
import CardsSection from './components/CardsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <RankingSection />
        <IndexSection />
        <CommentsSection />
        <AboutSection />
        <ContactSection />
        <UpdatesSection />
        <TopicsSection />
        <FeaturesSection />
        <AppSection />
        <FAQSection />
        <CarouselSection />
        <MediaSection />
        <CardsSection />
      </main>
      <Footer />
    </>
  );
}